import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReturnStreamPaste from '../ReturnStreamPaste';
import LineChartComponent from '../LineChartComponent/LineChartComponent';
import { sortRowsByDateAscending } from '../../utils/returnStreamRows';

const buildChartData = (rows = []) => {
  const normalizedRows = sortRowsByDateAscending(
    (Array.isArray(rows) ? rows : [])
      .filter((row) => row?.date != null && row?.return != null)
      .map((row) => ({
        date: String(row.date).trim(),
        return: Number.parseFloat(row.return),
      }))
      .filter((row) => row.date && !Number.isNaN(row.return)),
  );

  if (!normalizedRows.length) {
    return null;
  }

  let growth = 1;
  const cumulativeReturns = normalizedRows.map((row) => {
    growth *= 1 + row.return;
    return growth - 1;
  });

  return {
    labels: normalizedRows.map((row) => row.date),
    datasets: [{
      label: 'Cumulative Returns',
      data: cumulativeReturns,
      fill: false,
      borderColor: 'rgb(75, 192, 192)',
      tension: 0.1,
    }],
  };
};

const FundReturnInput = ({
  fund,
  updateFundReturns,
  pastedData,
  baseUrl = '',
  searchProviders = null,
}) => {
  const [expanded, setExpanded] = useState(true);
  const [pastedRows, setPastedRows] = useState(pastedData || []);
  const [selectedEtf, setSelectedEtf] = useState(fund?.selectedEtf || null);
  const [chartData, setChartData] = useState(() => buildChartData(pastedData || []));

  useEffect(() => {
    setPastedRows(pastedData || []);
    setChartData(buildChartData(pastedData || []));
  }, [pastedData]);

  useEffect(() => {
    setSelectedEtf(fund?.selectedEtf || null);
  }, [fund?.selectedEtf]);

  const handleClear = () => {
    setPastedRows([]);
    setSelectedEtf(null);
    setChartData(null);
    updateFundReturns([], null);
  };

  const handleSubmit = (rows, etfMetadata = null) => {
    setPastedRows(rows);
    setSelectedEtf(etfMetadata);
    setChartData(buildChartData(rows));
    updateFundReturns(rows, etfMetadata);
  };

  return (
    <Accordion expanded={expanded} onChange={(e, isExpanded) => setExpanded(isExpanded)} >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          {/* <TextField
            label="Description"
            variant="outlined"
            value={description}
            onChange={handleDescriptionChange}
            sx={{ width: 200 }}
            onClick={(event) => event.stopPropagation()}  // Prevents accordion action
          /> */}
          {pastedRows.length > 0 && (
            <CheckCircleIcon style={{ color: 'green', padding: '5px'}} fontSize='large'/>
          )}
          <Typography variant="subtitle2" color="textSecondary" sx={{ mt: 0.5 , pl: 1 , pr: 1}}>
            Paste monthly returns below (USD)
          </Typography>
        </Box>

      </AccordionSummary>
      <AccordionDetails>
        <ReturnStreamPaste
          onClear={handleClear}
          onSubmit={handleSubmit}
          initialRows={pastedRows}
          initialSelectedEtf={selectedEtf}
          baseUrl={baseUrl}
          searchProviders={searchProviders}
        />
        {chartData && <LineChartComponent chartData={chartData} />}
      </AccordionDetails>
    </Accordion>
  );
};

export default FundReturnInput;
